import React from "react";
import styles from "./styles.module.scss";
import { Spacing } from "spacing/component";
import { Button } from "components/buttons/Button";
import { TextHeadline3 } from "fonts/Headline3";
import IActionDialogProps from "../types/action";
export const ActionDialog = ({
  children,
  onActionClick,
  title,
  actionLabel
}: IActionDialogProps) => (
  <div className={styles.component}>
    <Spacing className={styles.content} ph="xs" pb="s" pt="2xl">
      <TextHeadline3>{title}</TextHeadline3>
      <div className={styles.children}>{children}</div>
      <Spacing pt="2xl" />
      {actionLabel && (
        <Button
          className={styles.button}
          text={actionLabel}
          onClick={onActionClick}
        />
      )}
    </Spacing>
  </div>
);
